import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {PropType} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
  modelValue: {
    type: String as PropType<string | null>,
    default: null,
  },
  label: {
    type: String,
    required: false,
    default: () => null,
  },
  icon: {
    type: String,
    required: false,
    default: () => null,
  },
  rules: {
    type: Array as PropType<Array<(data: any) => string | true>>,
    required: false,
    default: () => [],
  },
},
  emits: {
  'update:modelValue': (data: string | null) => data === null || typeof data === 'string',
},
  setup(__props) {






return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, {
    "model-value": __props.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    variant: "outlined",
    clearable: "",
    "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', null))),
    label: __props.label,
    "append-inner-icon": __props.icon,
    placeholder: "Datum filtern",
    type: "date",
    rules: __props.rules
  }, null, 8, ["model-value", "label", "append-inner-icon", "rules"]))
}
}

})